export default __webpack_public_path__ + "static/media/BrokenWheel.6975180b.gif";